import axios from 'axios'
import constants from '../lib/constants'
import _ from 'lodash'

// CONSTANTS
export const GET_CLIENTS = 'GET_CLIENTS'
export const GET_CLIENTS_COMPLETE = 'GET_CLIENTS_COMPLETE'
export const CREATE_CLIENT = 'CREATE_CLIENT'
export const CREATE_CLIENT_COMPLETE = 'CREATE_CLIENT_COMPLETE'
export const SET_CLIENT_VERSION = 'SET_CLIENT_VERSION'
export const SET_CLIENT_VERSION_COMPLETE = 'SET_CLIENT_VERSION_COMPLETE'

// ACTIONS
let TOKEN = localStorage.getItem('authToken')

if (TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
}

export const getClients = () => {
  return (dispatch, getState) => {
    dispatch({ type: GET_CLIENTS })
    return axios.get(`${constants.API_URL}/clients/list`)
    .then((response) => {
      const sortedClients = response.data.clients.sort((a, b) => (a.name > b.name ? 1 : -1))
      dispatch({
        type    : GET_CLIENTS_COMPLETE,
        payload : {
          clients: sortedClients,
        }
      })
      return response
    })
  }
}

export const createClient = (name) => {
  return (dispatch) => {
    dispatch({ type: CREATE_CLIENT })
    return axios.post(`${constants.API_URL}/clients/create`, { name })
    .then((response) => {
      const newClient = response.data
      dispatch({
        type    : CREATE_CLIENT_COMPLETE,
        payload : {
          createdClient: newClient
        }
      })
      return response
    })
  }
}

export const setClientVersion = (clientName, version, details) => {
  return (dispatch) => {
    dispatch({ type: SET_CLIENT_VERSION })
    return axios.post(`${constants.API_URL}/clients/${clientName}/interface-version`,
      {
        version,
        details,
      })
    .then((response) => {
      const updatedClient = response.data
      dispatch({
        type    : SET_CLIENT_VERSION_COMPLETE,
        payload : {
          updatedClient
        }
      })
      return response
    })
  }
}

// ACTION HANDLERS

const ACTION_HANDLERS = {
  [GET_CLIENTS_COMPLETE] : (state, action) => {
    const { clients } = action.payload
    const clientListObject = {}
    _.each(clients, (client) => {
      clientListObject[client.id] = client
    })
    const newState = {
      ...state,
      clients: clientListObject,
    }
    return newState
  },
  [CREATE_CLIENT_COMPLETE] : (state, action) => {
    const { createdClient } = action.payload
    const newState = {
      ...state,
      createdClient,
      clients: {
        ...state.clients,
        [createdClient.id]: createdClient
      }
    }
    return newState
  },
  [SET_CLIENT_VERSION_COMPLETE] : (state, action) => {
    const { updatedClient } = action.payload
    const newState = {
      ...state,
      updatedClient,
      clients: {
        ...state.clients,
        [updatedClient.client.id]: {
          ...state.clients[updatedClient.client.id],
          current_version: updatedClient.version.version,
        }
      }
    }
    return newState
  }
}

// REDUCER

const initialState = {
  clients: {},
  createdClient: null,
  updatedClient: null,
}

export default function clientsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/clients.js